
// import React, { useState, useEffect } from "react";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import JobList from "./JobList/JobList";
// import JobDetails from "./JobDetails/JobDetails";
// import ReactHtmlParser from "html-react-parser";
// import JobBoard from "./Template2/JobBoard";
// import styled from "styled-components";



// // export const BaseUrl = 'https://3j6lq1k0-3001.inc1.devtunnels.ms/api'

// // export const BaseUrl = 'https://tf2279ds-3001.inc1.devtunnels.ms/api';

// // const isDev = window.location.hostname === 'localhost';

// // export const BaseUrl = isDev
// //   ? 'https://hiremagic.in/api'
// //   : `${window.location.origin}/api`;


// export const BaseUrl = 'https://enwent.com/api'
// // export const BaseUrl = `${window.location.origin}/api`;

// const JobListings = () => {
//    const [filter,setfilter] = useState({
//    exp:null,
//     city:null,
//     type:null
//   })
//   const [jobs, setJobs] = useState([]);
//   const [jobDetails, setJobDetails] = useState(null);
//   const [department, setDepartment] = useState(null);
//   const [city, setCity] = useState(null);
//   const [state,setState] = useState(null);
//   const [country,setCountry] = useState(null);
//   const [error, setError] = useState(null);
//   const [styles, setStyles] = useState(null);
//   const navigate = useNavigate();
//   const queryParams = new URLSearchParams(window.location.search);
//   const customerName = queryParams.get("Y3VzdG9tZXJOYW1l");
// const [customername,setcustomername] = useState() 
//   const [encrypted,setencrypted] = useState()
//   const [params] = useSearchParams();
//   const jobid = params.get("jobid");
//   const id = params.get("id")

  
//  const getWho = async () => {

//   const data = {
//     who: params.get('who'),
//   };

//   try {
//     const res = await fetch(`${BaseUrl}/getDecryptedData`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(data), // 🔸 must stringify the body
//     });

//     const result = await res.json(); // 🔸 wait for the resolved value
//     if(result?.status){
//       return result?.message
//     }else{
//       return ""
//     }
//   } catch (err) {
//     console.error("Fetch error:", err);
//   }
// };

//   const getEncryptedData = async (str)=>{
//     const data = {
//       who:str
//     }
//     try{
//        const res = await fetch(`${BaseUrl}/getEncryptedData`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(data), // body must be a string
//     });
//       const result = await res.json()
//       if(result?.status){
//       return result?.message
//     }else{
//       return ""
//     }
//     }catch(err){

//     }
//   }
// useEffect(() => {

//   (async()=>{
//     const resultant = await getWho()
   
//     if(resultant){
//         setcustomername(resultant?.who)
//         setencrypted(await getEncryptedData(resultant?.who))
//     }
//     //  setencrypted(await getWho()?.who)
//   })()
// }, [params]);

// // ⭐ DYNAMIC TITLE USEEFFECT — ADD THIS
// useEffect(() => {
//   if (customername) {
//     document.title = customername;
//   }
// }, [customername]);

 





//   const styleApiUrl = `${BaseUrl}/customer/getEmbededCodeSettings?customerName=${customername}`;
     
  
//       const fetchStyle = async () => {
//          if(customername==='undefined' || customername===undefined) return;
//           try {
//               const styledData = await fetch(styleApiUrl);
//               const data = await styledData.json();
//               const result = data.message[0]; 
//               setStyles(result);
             
//           } catch (err) {
//               console.log(err.message);
//           }
//       };
  
//       useEffect(() => {
//         if(customername){
//             fetchStyle();
//         }
//       }, [customername]);

  

//   //console.log(",,,,",jobs)

//   const fetchJobs = async (domainName) => {
//     let apiUrl = `${BaseUrl}/customer/getiframeJobs?customerName=${customername}`
//     if(filter.exp?.split("-")?.[0] && filter.exp?.split("-")?.[1]){
//       apiUrl = apiUrl + `&from=${filter.exp?.split("-")?.[0] || null}&to=${filter.exp?.split("-")?.[1] || null}`
//     }
//     if(filter.city){
//       apiUrl = apiUrl + `&city=${filter.city || null}`
//     }
//     if(filter.type){
//       apiUrl = apiUrl + `&type=${filter.type || null}`
//     }
//     // const apiUrl = `${BaseUrl}/customer/getiframeJobs?customerName=${customername}&`;
    
//     try {
//       const response = await fetch(apiUrl);
//       if (!response.ok) {
//         throw new Error(`Failed to fetch jobs: ${response.status}`);
//       }
//       const data = await response.json();
      
//       if (Array.isArray(data.message)) {
//         setJobs(data.message);
        
        

//       } else {
//         setError("Jobs data is not in the expected format.");
//       }
//     } catch (err) {
//       setError(err.message);
//     }
//   };
//   //fetchJobs(customername);

//   const fetchJobDetails = async (domainName, jobid) => {
//     const apiUrl = `${BaseUrl}/customer/getCustomerJobById?customerName=${customername}&Jobid=${jobid}`;
    
//     try {
//       const response = await fetch(apiUrl);
//       if (!response.ok) {
//         throw new Error(`Failed to fetch job details: ${response.status}`);
//       }
//       const jobdetailsdata = await response.json();
//       setJobDetails(jobdetailsdata.message);
//     } catch (err) {
//       setError(err.message);
//     }
//   };
 
//   useEffect(() => {
//     if (jobid && customername) {
//       fetchJobDetails(customername, jobid);
//     }
//     else if(customername) {
//       fetchJobs(customername);
//     }
//   }, [customername,filter]);


//   // const fetchJobDetails = async (domainName, jobid) => {
//   //   const apiUrl = `https://3j6lq1k0-3001.inc1.devtunnels.ms/api/customer/getCustomerJobById?customerName=${domainName}&Jobid=${jobid}`;
//   //   try {
//   //     const response = await fetch(apiUrl);
//   //     if (!response.ok) {
//   //       throw new Error(`Failed to fetch job details: ${response.status}`);
//   //     }
//   //     const jobdetailsdata = await response.json();
//   //     setJobDetails(jobdetailsdata.message);
//   //     const jobDepartment = jobdetailsdata.message.find(
//   //       (field) => field["Job Deparment"] 
//   //     );
//   // console.log("dep id",jobDepartment )
//   //     if (jobDepartment && jobDepartment["Job Deparment"]) {
//   //       fetchDepartment(domainName, jobDepartment["Job Deparment"]);
//   //     }

//   //   } catch (err) {
//   //     setError(err.message);
//   //   }
//   // };
  
//   const [template,settemplate] = useState('list')
//   const handleBackToListings = () => {
//     setJobDetails(null);
//     navigate(`/api/iframe/job?who=${encrypted?.who}`)
//     fetchJobs(customerName);
    
//   };


//   const navigateToDetails = (id) => {
//     navigate(`/api/iframe/job?who=${encrypted?.who}&jobid=${id}`);
//   };

//   const renderHTML = (htmlString) => {
//     return ReactHtmlParser(htmlString);
//   };

//   const isLongContent = (value) => {
//     return (
//       typeof value === "string" &&
//       (value.length > 500 || value.includes("<") || value.includes(">"))
//     );
//   };


// const TextColor = styled.p`
//   color:${styles?.text_color};
// `;


//   return (
//     <div
//       style={{
//         width: "100%",
//         overflowX:'hidden',
//         borderRadius: "8px",
//         backgroundColor: "white",
//       }}
//     >
    

//     {/* <select
//   value={template}
//   onChange={(e) => settemplate(e.target.value)}
//   style={{
//     width: "200px",
//     padding: "10px",
//     border: "1px solid #ccc",
//     borderRadius: "8px",
//     backgroundColor: "white",
//     fontSize: "16px",
//     color: "#333",
//     cursor: "pointer",
//     transition: "all 0.3s ease",
//   }}
// >
//   <option value="list">List</option>
//   <option value="board">Board</option>
// </select> */}


//       {params.get('jobid') ? (
//         <>
//           <JobDetails

//             jobDetails={jobDetails}
//             customernameFromUrl={customername}
//             handleBackToListings={handleBackToListings}
//             renderHTML={renderHTML}
//             isLongContent={isLongContent}
//             department={department || "Loading..."}
//             city={city || "Loading...."}
//             state={state || "Loading...."}
//             country={country || "Loading..."}
//           />
//         </>
//       ) : template==='list'?(
//         <JobList
//           setfilters={setfilter}
//           filters={filter}
//           jobs={jobs}
//           error={error}
//           customerName={customername}
//           renderHTML={renderHTML}
//           navigateToDetails={navigateToDetails}
//           city={city || "loading"}
//           style={styles}
          
//         />
//       ):template==='board'?(
//            <JobBoard 
//           //  setfilters={setfilter}
//       jobs={jobs || []}
//       error={error}
//       customerName={customername}
//       renderHTML={renderHTML}
//       navigateToDetails={navigateToDetails}
//       city={city || "loading"}
//       />
//       ):(<></>)}
      
//     </div>
//   );
// };

// export default JobListings;




import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import JobList from "./JobList/JobList";
import JobDetails from "./JobDetails/JobDetails";
import ReactHtmlParser from "html-react-parser";
import JobBoard from "./Template2/JobBoard";
import styled from "styled-components";



// export const BaseUrl = 'https://3j6lq1k0-3001.inc1.devtunnels.ms/api'

// export const BaseUrl = 'https://tf2279ds-3001.inc1.devtunnels.ms/api';

// const isDev = window.location.hostname === 'localhost';

// export const BaseUrl = isDev
//   ? 'https://hiremagic.in/api'
//   : `${window.location.origin}/api`;

// export const BaseUrl = 'http://localhost:3001/api'
// export const BaseUrl = 'https://enwent.com/api'
export const BaseUrl = `${window.location.origin}/api`;


const JobListings = () => {
   const [filter,setfilter] = useState({
   exp:null,
    city:null,
    type:null
  })
  const [jobs, setJobs] = useState([]);
  const [jobDetails, setJobDetails] = useState(null);
  const [department, setDepartment] = useState(null);
  const [city, setCity] = useState(null);
  const [state,setState] = useState(null);
  const [country,setCountry] = useState(null);
  const [error, setError] = useState(null);
  const [styles, setStyles] = useState(null);
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const customerName = queryParams.get("Y3VzdG9tZXJOYW1l");
const [customername,setcustomername] = useState() 
  const [encrypted,setencrypted] = useState()
  const [params] = useSearchParams();
  const jobid = params.get("jobid");
  const id = params.get("id")

  
 const getWho = async () => {

  const data = {
    who: params.get('who'),
  };

  try {
    const res = await fetch(`${BaseUrl}/getDecryptedData`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data), // 🔸 must stringify the body
    });

    const result = await res.json(); // 🔸 wait for the resolved value
    if(result?.status){
      return result?.message
    }else{
      return ""
    }
  } catch (err) {
    console.error("Fetch error:", err);
  }
};

  const getEncryptedData = async (str)=>{
    const data = {
      who:str
    }
    try{
       const res = await fetch(`${BaseUrl}/getEncryptedData`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data), // body must be a string
    });
      const result = await res.json()
      if(result?.status){
      return result?.message
    }else{
      return ""
    }
    }catch(err){

    }
  }
useEffect(() => {

  (async()=>{
    const resultant = await getWho()
   
    if(resultant){
        setcustomername(resultant?.who)
        setencrypted(await getEncryptedData(resultant?.who))
    }
    //  setencrypted(await getWho()?.who)
  })()
}, [params]);

// ⭐ DYNAMIC TITLE USEEFFECT — ADD THIS
useEffect(() => {
  if (customername) {
    document.title = customername;
  }
}, [customername]);

 





  const styleApiUrl = `${BaseUrl}/customer/getEmbededCodeSettings?customerName=${customername}`;
     
  
      const fetchStyle = async () => {
         if(customername==='undefined' || customername===undefined) return;
          try {
              const styledData = await fetch(styleApiUrl);
              const data = await styledData.json();
              const result = data.message[0]; 
              setStyles(result);
             
          } catch (err) {
              console.log(err.message);
          }
      };
  
      useEffect(() => {
        if(customername){
            fetchStyle();
        }
      }, [customername]);

  

  //console.log(",,,,",jobs)

  const fetchJobs = async (domainName) => {
    let apiUrl = `${BaseUrl}/customer/getiframeJobs?customerName=${customername}`
    if(filter.exp?.split("-")?.[0] && filter.exp?.split("-")?.[1]){
      apiUrl = apiUrl + `&from=${filter.exp?.split("-")?.[0] || null}&to=${filter.exp?.split("-")?.[1] || null}`
    }
    if(filter.city){
      apiUrl = apiUrl + `&city=${filter.city || null}`
    }
    if(filter.type){
      apiUrl = apiUrl + `&type=${filter.type || null}`
    }
    // const apiUrl = `${BaseUrl}/customer/getiframeJobs?customerName=${customername}&`;
    
    try {
      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error(`Failed to fetch jobs: ${response.status}`);
      }
      const data = await response.json();
      
      if (Array.isArray(data.message)) {
        setJobs(data.message);
        
        

      } else {
        setError("Jobs data is not in the expected format.");
      }
    } catch (err) {
      setError(err.message);
    }
  };
  //fetchJobs(customername);

  const fetchJobDetails = async (domainName, jobid) => {
    const apiUrl = `${BaseUrl}/customer/public/getJobById?customerName=${customername}&Jobid=${jobid}`;
    
    try {
      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error(`Failed to fetch job details: ${response.status}`);
      }
      const jobdetailsdata = await response.json();
      setJobDetails(jobdetailsdata.message);
    } catch (err) {
      setError(err.message);
    }
  };
 
  useEffect(() => {
    if (jobid && customername) {
      fetchJobDetails(customername, jobid);
    }
    else if(customername) {
      fetchJobs(customername);
    }
  }, [customername,filter]);


  // const fetchJobDetails = async (domainName, jobid) => {
  //   const apiUrl = `https://3j6lq1k0-3001.inc1.devtunnels.ms/api/customer/getCustomerJobById?customerName=${domainName}&Jobid=${jobid}`;
  //   try {
  //     const response = await fetch(apiUrl);
  //     if (!response.ok) {
  //       throw new Error(`Failed to fetch job details: ${response.status}`);
  //     }
  //     const jobdetailsdata = await response.json();
  //     setJobDetails(jobdetailsdata.message);
  //     const jobDepartment = jobdetailsdata.message.find(
  //       (field) => field["Job Deparment"] 
  //     );
  // console.log("dep id",jobDepartment )
  //     if (jobDepartment && jobDepartment["Job Deparment"]) {
  //       fetchDepartment(domainName, jobDepartment["Job Deparment"]);
  //     }

  //   } catch (err) {
  //     setError(err.message);
  //   }
  // };
  
  const [template,settemplate] = useState('list')
  const handleBackToListings = () => {
    setJobDetails(null);
    navigate(`/api/iframe/job?who=${encrypted?.who}`)
    fetchJobs(customerName);
    
  };


  const navigateToDetails = (id) => {
    navigate(`/api/iframe/job?who=${encrypted?.who}&jobid=${id}`);
  };

  const renderHTML = (htmlString) => {
    return ReactHtmlParser(htmlString);
  };

  const isLongContent = (value) => {
    return (
      typeof value === "string" &&
      (value.length > 500 || value.includes("<") || value.includes(">"))
    );
  };


const TextColor = styled.p`
  color:${styles?.text_color};
`;


  return (
    <div
      style={{
        width: "100%",
        overflowX:'hidden',
        borderRadius: "8px",
        backgroundColor: "white",
      }}
    >
    

    {/* <select
  value={template}
  onChange={(e) => settemplate(e.target.value)}
  style={{
    width: "200px",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    backgroundColor: "white",
    fontSize: "16px",
    color: "#333",
    cursor: "pointer",
    transition: "all 0.3s ease",
  }}
>
  <option value="list">List</option>
  <option value="board">Board</option>
</select> */}


      {params.get('jobid') ? (
        <>
          <JobDetails

            jobDetails={jobDetails}
            customernameFromUrl={customername}
            handleBackToListings={handleBackToListings}
            renderHTML={renderHTML}
            isLongContent={isLongContent}
            department={department || "Loading..."}
            city={city || "Loading...."}
            state={state || "Loading...."}
            country={country || "Loading..."}
          />
        </>
      ) : template==='list'?(
        <JobList
          setfilters={setfilter}
          filters={filter}
          jobs={jobs}
          error={error}
          customerName={customername}
          renderHTML={renderHTML}
          navigateToDetails={navigateToDetails}
          city={city || "loading"}
          style={styles}
          
        />
      ):template==='board'?(
           <JobBoard 
          //  setfilters={setfilter}
      jobs={jobs || []}
      error={error}
      customerName={customername}
      renderHTML={renderHTML}
      navigateToDetails={navigateToDetails}
      city={city || "loading"}
      />
      ):(<></>)}
      
    </div>
  );
};

export default JobListings;



















































































































































